import ActionTypes from './constants';

export function creditCardFetched(cards) {
  return (dispatch) => {
    dispatch(fetchedCreditCard(cards));
  };
}

function fetchedCreditCard(cards) {
  return {
    type: ActionTypes.FetchedCreditCards,
    cards,
  };
}

export function creditCardAdyenFetched(cards) {
  return (dispatch) => {
    dispatch(fetchedCreditCardAdyen(cards));
  };
}

function fetchedCreditCardAdyen(cards) {
  return {
    type: ActionTypes.FetchedCreditCardsAdyen,
    cards,
  };
}
